import React from 'react';
import { TrendingUp, AlertCircle, Shield } from 'lucide-react';

const WhyCareerLiftExistsSection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 relative overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl animate-pulse animation-delay-2000"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Main Content */}
        <div className="text-center mb-16 scroll-reveal">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8 leading-tight">
            Don't Get Left Behind as the World Evolves
          </h2>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20 text-left">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 mt-1">
                  <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center">
                    <AlertCircle className="w-6 h-6 text-gray-900" />
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-3">
                    By 2030, over 70% of jobs will require AI literacy and future-ready skills.
                  </h3>
                  <p className="text-blue-100 text-lg leading-relaxed">
                    The workforce is transforming at an unprecedented pace. Students who don't adapt risk being left behind in a world where technology and innovation rule.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20 text-left">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 mt-1">
                  <div className="w-12 h-12 bg-red-400 rounded-full flex items-center justify-center">
                    <TrendingUp className="w-6 h-6 text-white" />
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-3">
                    Most students struggle not because they lack talent — but because they lack guidance.
                  </h3>
                  <p className="text-blue-100 text-lg leading-relaxed">
                    Without a clear roadmap, even the brightest students feel lost. Traditional education doesn't teach you how to navigate the modern job market.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 border border-white/20 text-left shadow-2xl transform hover:scale-105 transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 mt-1">
                  <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center">
                    <Shield className="w-6 h-6 text-gray-900" />
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-3">
                    CareerLift bridges that gap with a step-by-step success path.
                  </h3>
                  <p className="text-white/90 text-lg leading-relaxed">
                    We provide clarity, skills, and confidence — everything you need to go from confusion to career success. No guesswork. Just results.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center scroll-reveal">
          <button
            onClick={() => {
              const frameworkSection = document.getElementById('success-framework');
              if (frameworkSection) {
                frameworkSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-yellow-400 hover:bg-yellow-300 text-gray-900 font-bold px-12 py-5 rounded-full text-lg shadow-2xl transform hover:scale-105 transition-all duration-300 inline-flex items-center gap-3"
          >
            Discover the Framework
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      </div>

      <style jsx>{`
        .animation-delay-2000 {
          animation-delay: 2s;
        }
      `}</style>
    </section>
  );
};

export default WhyCareerLiftExistsSection;
